import { render, staticRenderFns } from "./ContactDetails.vue?vue&type=template&id=0377b46a"
import script from "./ContactDetails.vue?vue&type=script&lang=js"
export * from "./ContactDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports